export default {
  nav_items: {
    menu: 'Menü',
    locations: 'Standorte',
    store_info: 'Store-Details',
  },
};
